import { Link } from "react-router-dom";
import useScrollAnimation from "../useScrollAnimation";
export default function Home() {
  useScrollAnimation();
  return (
    <>
      {/* HERO SECTION */}
      <section className="hero-advanced">
        <div className="hero-overlay"></div>

        <div className="hero-advanced-content">
          <h1 className="fade-down">
            CHERRY SELF DRIVE CARS TIRUPATI
          </h1>
          <p className="fade-up">
            Affordable and reliable self drive car rentals in Tirupati.
            Enjoy freedom to travel at your own pace with well maintained vehicles.
            Open 24/7 for your convenience.
          </p>

          <div className="hero-buttons fade-up">
            <Link to="/booking" className="btn-gradient">Book on WhatsApp</Link>
            <Link to="/cars" className="btn-outline">View Cars</Link>
          </div>
        </div>
      </section>

      {/* TRUST STRIP */}
      <section className="trust-strip animate-on-scroll">
        <div>✔ 5+ Years Experience</div>
        <div>✔ 390+ Happy Customers</div>
        <div>✔ Well Maintained Cars</div>
        <div>✔ 24/7 Support</div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="glass-section animate-on-scroll">
        <h2 className="section-title">Why Choose Us</h2>
        <p className="section-subtitle">
          We provide safe, affordable and reliable self drive cars with transparent pricing.
        </p>

        <div className="features">
          <div className="feature-box float">
            🚗 <h4>Modern Fleet</h4>
            <p>Wide range of well maintained self drive cars.</p>
          </div>

          <div className="feature-box float">
            💰 <h4>No Hidden Charges</h4>
            <p>Clear pricing with full transparency.</p>
          </div>

          <div className="feature-box float">
            📲 <h4>Instant Booking</h4>
            <p>Book your self drive car via WhatsApp easily.</p>
          </div>

          <div className="feature-box float">
            🔑 <h4>Self Drive Freedom</h4>
            <p>Drive on your own with full privacy and comfort.</p>
          </div>
        </div>
      </section>

      {/* FEATURED CARS */}
        <section className="glass-section animate-on-scroll">
          <h2 className="section-title">Popular Self Drive Cars</h2>
          <p className="section-subtitle">
            Choose from our best-selling self drive cars.
          </p>

          <div className="cars-grid">
            <div className="car-card hover-rise">
              <img
                src="https://i.ibb.co/HDBRhYwW/maruti-swift.avif"
                alt="Maruti Swift Dzire"
                className="car-img"
              />
              <h3>Swift Dzire</h3>
              <p>Seating: 5 Seater</p>
              <p>Transmission: Manual</p>
              <p><b>₹2000 / day</b></p>
              <Link to="/booking" className="book-link">Book Now</Link>
            </div>

            <div className="car-card hover-rise">
              <img
                src="https://i.ibb.co/j9zRWkJd/Hrundai-creta.webp"
                alt="Hyundai Creta"
                className="car-img"
              />
              <h3>Hyundai Creta</h3>
              <p>Seating: 5 Seater</p>
              <p>Transmission: Manual / Automatic</p>
              <p><b>₹3000 / day</b></p>
              <Link to="/booking" className="book-link">Book Now</Link>
            </div>

            <div className="car-card hover-rise">
              <img
                src="https://i.ibb.co/WN7xGcKC/innova-crysta.jpg"
                alt="Innova Crysta"
                className="car-img"
              />
              <h3>Innova Crysta</h3>
              <p>Seating: 7 Seater</p>
              <p>Transmission: Manual</p>
              <p><b>₹3500 / day</b></p>
              <Link to="/booking" className="book-link">Book Now</Link>
            </div>
          </div>

          {/* VIEW ALL CARS BUTTON */}
          <div style={{ marginTop: "30px", textAlign: "center" }}>
            <Link to="/cars" className="view-all-btn">View All Cars</Link>
          </div>
        </section>

      {/* CUSTOMER REVIEWS */}
      <section className="review-section animate-on-scroll">
        <h2>Trusted by 390+ Happy Customers</h2>
        <p>⭐ 5 / 5 (Verified Google Reviews)</p>

        <div className="review-grid">
          
          {/* REVIEW 1 */}
          <div className="review-card-modern">
            <div className="review-header">
              <div className="review-avatar">R</div>
              <div>
                <h4>Rohith Kumar</h4>
                <span className="review-time">6 months ago</span>
              </div>
            </div>

            <div className="review-stars">★★★★★</div>

            <p className="review-text">
              <span className="quote-mark">“</span>
              "I had a great experience renting a car from Cherry Self Drive Cars in Tirupati.
              I opted for the Baleno, and the vehicle was in excellent condition—absolutely
              no issues during the entire trip..."
            </p>

            <div className="review-verified">✔ Verified Google Review</div>

            <a
              href="https://maps.app.goo.gl/tvvuooYkjt2cHfDB7"
              target="_blank"
              rel="noreferrer"
              className="read-review-btn"
            >
              Read Full Review
            </a>
          </div>

          {/* REVIEW 2 */}
          <div className="review-card-modern">
            <div className="review-header">
              <div className="review-avatar">A</div>
              <div>
                <h4>Arun ky</h4>
                <span className="review-time">2 weeks ago</span>
              </div>
            </div>

            <div className="review-stars">★★★★★</div>

            <p className="review-text">
              <span className="quote-mark">“</span>
              "Very friendly and quick response, I enquired about self drive car Ertiga
              and they delivered at my location within 20 mins of time..."
            </p>

            <div className="review-verified">✔ Verified Google Review</div>

            <a
              href="https://maps.app.goo.gl/6xcXLETg6FLoubGE7"
              target="_blank"
              rel="noreferrer"
              className="read-review-btn"
            >
              Read Full Review
            </a>
          </div>

          {/* REVIEW 3 */}
          <div className="review-card-modern">
            <div className="review-header">
              <div className="review-avatar">N</div>
              <div>
                <h4>Nikhil Patil</h4>
                <span className="review-time">2 weeks ago</span>
              </div>
            </div>

            <div className="review-stars">★★★★★</div>

            <p className="review-text">
              <span className="quote-mark">“</span>
              "Amazing service, car was in good condition. Great customer service and smooth experience!..."
            </p>

            <div className="review-verified">✔ Verified Google Review</div>

            <a
              href="https://maps.app.goo.gl/Lf4SLfDfEsEk29cU7"
              target="_blank"
              rel="noreferrer"
              className="read-review-btn"
            >
              Read Full Review
            </a>
          </div>
        </div>

        <a
          href="https://maps.app.goo.gl/Yj2eyBJDsyHjLzwc8"
          target="_blank"
          rel="noreferrer"
          className="review-btn"
        >
          Write a Review on Google
        </a>
      </section>

      {/* EXPLORE PLACES */}
      <section className="explore-section animate-on-scroll">
        <h2>Explore Beyond Tirupati</h2>

        <div className="explore-grid">
          <div className="explore-card animate-place">
            <img
              src="https://dwarakatirumala.co.in/wp-content/uploads/2024/12/chittoor_P4281-1024x680.webp"
              alt="Kanipakam"
              className="explore-img"
            />
            <h3>Kanipakam (70 KM)</h3>
            <p>Famous for Sri Varasiddhi Vinayaka Temple.</p>
          </div>

          <div className="explore-card animate-place delay-1">
            <img
              src="https://s3.india.com/wp-content/uploads/2025/07/Srikalahasti-Nearby-Attractions.jpg##image/jpg"
              alt="Srikalahasti"
              className="explore-img"
            />
            <h3>Srikalahasti (40 KM)</h3>
            <p>Known for Rahu Ketu Pooja and ancient Shiva temple.</p>
          </div>

          <div className="explore-card animate-place delay-2">
            <img
              src="https://s7ap1.scene7.com/is/image/incredibleindia/talakona-waterfall-tirupati-andhra-pradesh-1-attr-hero?qlt=82&ts=1742150676739"
              alt="Talakona"
              className="explore-img"
            />
            <h3>Talakona (60 KM)</h3>
            <p>Highest waterfall in Andhra Pradesh with forest views.</p>
          </div>
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="office-map-section fade-in-map animate-on-scroll">
        <div className="map-heading">
          <span className="map-tag">FIND US</span>
          <h2>Our Office Location</h2>
          <p>Visit us for pickup or documentation</p>
        </div>

        <div className="map-container">
          <iframe
            title="map"
            src="https://maps.google.com/maps?q=Cherry%20Self%20Drive%20Cars%20Tirupati&t=&z=16&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            loading="lazy"
          ></iframe>
        </div>

        <div className="map-actions">
          <a
            href="https://maps.app.goo.gl/dwxJXZBsyxS94TEu9"
            target="_blank"
            rel="noreferrer"
            className="directions-btn"
          >
            📍 Get Directions
          </a>
        </div>

        <div className="map-info-grid">
          <div className="map-info-card">
            <h4>📍 Address</h4>
            <p>
              padmavathi Park Next, 6-9-S7-279,<br />
              K.B Layout, Right,<br />
              Tirupati, Andhra Pradesh 517501
            </p>
          </div>

          <div className="map-info-card">
            <h4>⏰ Business Hours</h4>
            <p>Open 24 Hours (7 Days a Week)</p>
          </div>
        </div>
      </section>
    </>
  );
}
